export default __webpack_public_path__ + "static/media/search-ios-placeholder.a3b2a0d0034cf2bb6410fc660a490738.svg";